<script>
    import constants from '@/constants';

    export default {
        computed: {
            version() {return constants.VERSION},
        }
    }
</script>


<template>
    <label>{{ version }}</label>
</template>


<style scoped>
    label {
        position: fixed;
        bottom: 5px;
        right: 5px;
        color: #ffffff;
        z-index: 99;
        background-color: var(--left-panel);
        border-radius: 5px;
        padding: 5px;
    }
</style>